import BaseComponent from "../base-component.js";
import FeedbackContainer from "../reports/feedback-container.jsx";
import rubricReport from "../reports/rubric-report.jsx";

class ScoreOnlyQuestionComponent extends BaseComponent {
  render() {
    return(this.wrapper(this.body(), this.props.teacherResponse?.text_feedback ? FeedbackContainer({feedbackText: this.props.teacherResponse.text_feedback}) : null,this.props.rubricReport ? rubricReport({rubricReport: this.props.rubricReport}) : null));
  }
}

export default ScoreOnlyQuestionComponent